var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttributesMenuItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Out_line",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Out line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m128 16h-80a32.03635 32.03635 0 0 0 -32 32v144a32.03635 32.03635 0 0 0 32 32h80a32.03635 32.03635 0 0 0 32-32v-144a32.03635 32.03635 0 0 0 -32-32zm-80 16h80a16.01833 16.01833 0 0 1 16 16v32h-112v-32a16.01833 16.01833 0 0 1 16-16zm80 176h-80a16.01833 16.01833 0 0 1 -16-16v-96h112v96a16.01833 16.01833 0 0 1 -16 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48 48h32v16h-32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96 48h32v16h-32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m48 112h32v16h-32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m96 112h32v16h-32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m48 144h32v16h-32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96 144h16v16h-16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m48 176h32v16h-32z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m96 176h32v16h-32z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m208 168a32.03635 32.03635 0 0 0 -32-32h-8v16h8a16.01833 16.01833 0 0 1 16 16 32.03635 32.03635 0 0 0 32 32h8v-16h-8a16.01833 16.01833 0 0 1 -16-16z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m352 264v-112a32.03635 32.03635 0 0 0 -32-32h-48a32.03635 32.03635 0 0 0 -32 32v112a32.03635 32.03635 0 0 0 32 32h48a32.03635 32.03635 0 0 0 32-32zm-80-128h48a16.01833 16.01833 0 0 1 16 16v32h-80v-32a16.01833 16.01833 0 0 1 16-16zm-16 128v-64h80v64a16.01833 16.01833 0 0 1 -16 16h-48a16.01833 16.01833 0 0 1 -16-16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m272 152h32v16h-32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m272 216h32v16h-32z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m272 248h32v16h-32z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m464 120h-48a32.03635 32.03635 0 0 0 -32 32v112a32.03635 32.03635 0 0 0 32 32h48a32.03635 32.03635 0 0 0 32-32v-112a32.03635 32.03635 0 0 0 -32-32zm-48 16h48a16.01833 16.01833 0 0 1 16 16v32h-80v-32a16.01833 16.01833 0 0 1 16-16zm48 144h-48a16.01833 16.01833 0 0 1 -16-16v-64h80v64a16.01833 16.01833 0 0 1 -16 16z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m416 152h32v16h-32z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m416 216h32v16h-32z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m416 248h32v16h-32z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m464 320h-48a32.03635 32.03635 0 0 0 -32 32v112a32.03635 32.03635 0 0 0 32 32h48a32.03635 32.03635 0 0 0 32-32v-112a32.03635 32.03635 0 0 0 -32-32zm-48 16h48a16.01833 16.01833 0 0 1 16 16v32h-80v-32a16.01833 16.01833 0 0 1 16-16zm48 144h-48a16.01833 16.01833 0 0 1 -16-16v-64h80v64a16.01833 16.01833 0 0 1 -16 16z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m416 352h32v16h-32z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m416 416h32v16h-32z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m416 448h32v16h-32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m360 192h16v16h-16z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m304 336v-32h-16v32a40.04552 40.04552 0 0 0 40 40h48v-16h-48a24.02718 24.02718 0 0 1 -24-24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesMenuItem);
export default __webpack_public_path__ + "static/media/AttributesMenuItem.a252d948.svg";
export { ForwardRef as ReactComponent };